import {InjectionToken} from '@angular/core';

export const TINYMCE_CONFIG = new InjectionToken<any>('tinymce config global');
